const Rightbar = (props) => {
  // console.log("Rightbar props:", props.listTargets);
  return (
    <>
      <button
        id="toggleSidebarBtn"
        type="button"
        className="btn btn-warning mr-0 py-1 mb-3"
        title="Carrello rewards"
        onClick={() => {
          document.querySelector('.right-sidebar').classList.toggle('showSidebar');
          document.querySelector('#toggleSidebarBtn').classList.toggle('showSidebar');
          document.querySelector('#cardsContainer').classList.toggle('col-lg-10');
          document.querySelector('#cardsContainer').classList.toggle('col-lg-12');
        }}
      >
        <div className="mb-2">{props.listTargets.length}</div>
        <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
          shopping_cart
        </span>
      </button>
      <aside className="right-sidebar">
        {props.rewards}
      </aside>
    </>
  );
}
export default Rightbar;